import {filter} from 'rxjs/operators';

export function filterNilVal() {
  return filter(v => v != null);
}

// export function filterNilVal<T>(value: T) {
//   return filter(v => v != null);
// }
